/* YG Home — Best Sellers. Tab SWITCHING itself is handled by the theme's
   existing generic tabs() function (assets/yg-home.js, data-yg-tabs/
   data-yg-panel) — previously dead code, since nothing used those
   attributes until this section. This file adds two things specific to
   Best Sellers:
   1. Scrolling a clicked mobile tab into view within its horizontally-
      scrollable row (reference: shiftPillToStart, IG overlay JS) —
      disclosed addition, not a source-verified port of that exact function.
   2. Re-measuring each revealed panel's carousel. Every tab's carousel is a
      real, independent Swiper instance initialised at page load while its
      panel is still `hidden` — a carousel measured with zero container
      width can get its slide count/scrollbar ratio/arrow-disabled state
      wrong, and nothing corrects that until something calls update() after
      the container actually has a size. yg-home.js's tabs() only toggles
      `hidden`/classes, so this listens for the SAME click, runs after it
      (attached after the generic listener, so `hidden` is already updated
      by the time this fires), and calls .update() on the now-visible
      panel's own carousel instance (stored as root.__ygSwiper by
      yg-carousel.js). Matters most for the "All" tab specifically, since
      its slide count differs from every other tab's. */
(function () {
  'use strict';

  function updateVisiblePanelCarousel(section) {
    var panel = section.querySelector('.yg-bs-panel:not([hidden])');
    if (!panel) return;
    var root = panel.querySelector('[data-yg-carousel-root]');
    if (!root || !root.__ygSwiper) return;
    root.__ygSwiper.update();
    if (root.__ygSwiper.updateAutoHeight) root.__ygSwiper.updateAutoHeight(0);
    window.setTimeout(function () {
      root.__ygSwiper.update();
      if (root.__ygSwiper.updateAutoHeight) root.__ygSwiper.updateAutoHeight(0);
    }, 80);
    window.setTimeout(function () {
      root.__ygSwiper.update();
      if (root.__ygSwiper.updateAutoHeight) root.__ygSwiper.updateAutoHeight(0);
    }, 260);
  }

  function animateVisiblePanel(section, index) {
    var panel = section.querySelectorAll('.yg-bs-panel')[index];
    if (!panel || panel.hidden) return;

    panel.classList.remove('yg-bs-panel--enter');
    panel.offsetHeight;
    panel.classList.add('yg-bs-panel--enter');
    window.setTimeout(function () {
      panel.classList.remove('yg-bs-panel--enter');
    }, 520);
  }

  function init(root) {
    (root || document).querySelectorAll('.yg-bs').forEach(function (section) {
      if (section.__ygBsTabs) return;
      section.__ygBsTabs = true;
      var tabs = section.querySelector('.yg-bs-tabs');
      if (!tabs) return;
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('.yg-lw-tab'));
      section.__ygBsActiveIndex = btns.findIndex(function (btn) { return btn.classList.contains('is-on'); });
      if (section.__ygBsActiveIndex < 0) section.__ygBsActiveIndex = 0;

      btns.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          var wasActive = section.__ygBsActiveIndex === index;
          section.__ygBsActiveIndex = index;

          window.requestAnimationFrame(function () {
            updateVisiblePanelCarousel(section);
            if (!wasActive) animateVisiblePanel(section, index);
          });

          if (window.matchMedia('(min-width: 990px)').matches) return;
          if (wasActive && !tabs.classList.contains('is-open')) {
            tabs.classList.add('is-open');
            return;
          }
          tabs.classList.remove('is-open');
        });
      });

      document.addEventListener('click', function (event) {
        if (!tabs.classList.contains('is-open')) return;
        if (tabs.contains(event.target)) return;
        tabs.classList.remove('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
